<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzTitle="Leads" nzSubtitle=" - Lista dos leads cadastrados.">
        <nz-page-header-extra>
            <button nz-button nzType="primary" (click)="abrirModalExportacaoLead()">Exportação (.csv)</button>
            <button nz-button nz-dropdown [nzDropdownMenu]="menu" style="border: none; padding: 0; margin-left: 0px;">
                <i nz-icon nzType="more" nzTheme="outline" style="font-size: 20px; vertical-align: top;"></i>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                    <li nz-menu-item routerLink="/lead/exportacao">Lista de Exportações</li>
                </ul>
            </nz-dropdown-menu>
        </nz-page-header-extra>
    </nz-page-header>

    <div nz-row>

        <div nz-col nzSpan="24">
            <nz-divider></nz-divider>
        </div>
        <div nz-col nzSpan="19" style="margin-bottom:10px;">
            <nz-input-group nzCompact nzSearch [nzAddOnAfter]="suffixIconButton">
                <input type="text" [(ngModel)]="search" style="min-width: 500px!important;" nz-input placeholder="Pesquise pelo nome do usuário" />

            </nz-input-group>
            <ng-template #suffixIconButton>
                <button nz-button nzType="primary" (click)="searchUsuario()" nzSearch><i nz-icon nzType="search"></i></button>
            </ng-template>
        </div>
        <div nz-col nzSpan="4" style="margin-left: 10px;">
            <button nz-button nzType="danger" *ngIf="!isVisibleCancelFiltro" disabled (click)="removerFiltro()"><i nz-icon nzType="close-circle" nzTheme="outline"></i> Cancelar Pesquisa</button>
            <button nz-button nzType="danger" *ngIf="isVisibleCancelFiltro" (click)="removerFiltro()"><i nz-icon nzType="close-circle" nzTheme="outline"></i> Cancelar Pesquisa</button>
        </div>

        <div nz-col nzSpan="24">
            <nz-table #basicTable (nzQueryParams)="onQueryParamsChange($event)" nzSize="small" [(nzData)]="leads" [nzFrontPagination]="false" [nzLoading]="loading" [nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex">
                <thead>
                    <tr>
                        <th></th>
                        <th>#</th>
                        <th>Tipo</th>
                        <th>Empresa</th>
                        <th style="text-align: center;">Tipo</th>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>Cadastrado em</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-data [(ngForOf)]="basicTable.data">
                        <tr>
                            <td [nzExpand]="expandSet.has(data.id)" (nzExpandChange)="onExpandChange(data.id, $event)"></td>
                            <td>{{data.id}}</td>
                            <td style="text-align: center;">
                                <nz-tag *ngIf="data.ativo" [nzColor]="'green'">Ativo</nz-tag>
                                <nz-tag *ngIf="!data.ativo && !data.anonimizado" [nzColor]="'red'">Inativo</nz-tag>
                                <nz-tag *ngIf="!data.ativo && data.anonimizado" [nzColor]="'red'">Anonimizado</nz-tag> <br *ngIf="!data.ativo && data.anonimizado">
                                <small *ngIf="!data.ativo && data.anonimizado">{{data.anonimizado | date:"dd/MM/yyyy HH:mm:ss"}}</small>
                            </td>
                            <td>
                                <strong>CNPJ: </strong> {{data.cnpj}} <br>
                                <strong>Razão Social: </strong> {{data.razao_social}} <br>
                                <strong>Nome Fantasia: </strong> {{data.nome_fantasia}}
                            </td>
                            <td>{{data.nome}}</td>

                            <td>{{data.email}}</td>
                            <td>{{data.created_at | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                            <td>
                                <button nz-button nz-dropdown [nzDropdownMenu]="menu">Operações<i nz-icon
                                        nzType="down"></i></button>
                                <nz-dropdown-menu #menu="nzDropdownMenu">
                                    <ul nz-menu>
                                        <li nz-menu-item>
                                            <a style="color:#f63849;" *ngIf="data.ativo === 1 && !data.anonimizado" (click)="inativar(data.id)">Inativar</a>
                                            <a style="color:#27ae60;" *ngIf="data.ativo === 0 && !data.anonimizado" (click)="ativar(data.id)">Ativar</a>

                                            <a style="color:#f63849;" *ngIf="data.ativo === 0"  nz-popconfirm
                                            nzPopconfirmTitle="Deseja realmente realizar a exclusão do usuário?"
                                            nzOkText="Sim, desejo continuar"
                                            nzCancelText="Não"
                                            (nzOnConfirm)="excluir(data.id)"
                                            >Excluir</a>
                                        </li>
                                    </ul>
                                </nz-dropdown-menu>
                            </td>
                        </tr>
                        <!--LISTAGEM DE TOKENS -->
                        <tr [nzExpand]="expandSet.has(data.id)">
                            <div style="margin-top: 10px; margin-left: -30px; margin-bottom: 30px;">
                                <nz-table #tokenTable nzSize="small" nzFrontPagination="false" nzShowPagination="false" [nzData]="data.personal_access_token">
                                    <thead>
                                        <tr>
                                            <th>Dispositivo</th>
                                            <th>Criado em</th>
                                            <th>Ultimo Acesso</th>
                                        </tr>
                                    </thead>    
                                    <tbody>    
                                            <tr *ngFor="let token of tokenTable.data">
                                                <td>{{token.name}}</td>
                                                <td>{{token.created_at | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                                                <td>{{token.last_used_at ? (token.last_used_at | date: 'dd/MM/yyyy HH:mm:ss') : ' - '}}</td>
                                            </tr>
                                        </tbody>
                                </nz-table>
                            </div>
                        </tr>

                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    </div>
</div>

<nz-modal nzWidth="400px" [(nzVisible)]="visibilidadeModalExportacaoLead" nzTitle="Exportação de Leads" (nzOnCancel)="fecharModalExportacaoLead()" [nzFooter]="null">
    <ng-container *nzModalContent>
    <app-exportacao-lead (concluido)="fecharModalExportacaoLead()"></app-exportacao-lead>
    </ng-container>
</nz-modal>